import { createFileRoute } from '@tanstack/react-router';

import { WatchView } from 'views/WatchView';

export const Route = createFileRoute('/_auth/_layout/watch/')({
  component: WatchView,
  staticData: {
    title: 'Watch',
  },
});
